export default {
  'baseUrl': process.env.VUE_APP_BASE_URL,
  'uploadAddr': process.env.VUE_APP_UPLOAD_ADDR,
  'obWebUrl': process.env.VUE_APP_WEB_URL,
  'platformCode': process.env.VUE_APP_PLATFORM_CODE,
  'title': process.env.VUE_APP_TITLE
}